import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { usePrefs, useLabels } from 'wsm-common-data';
import filterVehiclesWithoutInventory from '../utils/filterVehiclesWithoutInventory';
import { groupUniqueVehicles } from '../utils/groupUniqueVehicles';
import { inventoryCountsSelector } from '../server/selectors';
import { addModelInv } from '../utils/inventoryUtils';

export const useProcessVehicles = (data) => {
	const { excludeModelsWithoutInventory, showAllModelsTab } = usePrefs();
	const inventoryCounts = useSelector(inventoryCountsSelector);
	const labels = useLabels();
	return useMemo(() => {
		let processedVehicles;
		if (
			excludeModelsWithoutInventory === 'true' &&
			inventoryCounts &&
			Object.keys(inventoryCounts).length
		) {
			processedVehicles = filterVehiclesWithoutInventory(
				data,
				inventoryCounts
			);
		} else {
			processedVehicles = { ...data };
		}

		if (showAllModelsTab === 'true' && processedVehicles) {
			const allCars = groupUniqueVehicles(processedVehicles);
			const allLabel = labels.get('ALL');
			processedVehicles[allLabel] = [...allCars];
		}

		processedVehicles = addModelInv(processedVehicles, inventoryCounts);

		return processedVehicles;
	}, [
		data,
		inventoryCounts,
		excludeModelsWithoutInventory,
		labels,
		showAllModelsTab
	]);
};
